import { type CommonInputProps, useInput } from "react-admin";

import { CodeEditor } from "@/components/CodeEditor";

export const HTMLInput = ({ onBlur, onChange, ...rest }: CommonInputProps) => {
  const { field } = useInput({
    onBlur,
    onChange,
    ...rest,
  });

  return (
    <CodeEditor
      language="html"
      {...field}
      height="600px"
      options={{ wordWrap: "on" }}
    />
  );
};
